// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import UserConstants from 'constants/UserConstants'
import GateConstants from 'constants/GateConstants'

const GateStore = Marty.createStore({
  id: 'GateStore',

  getInitialState() { return {
    gates: {}
  } },

  handlers: {
    fetchCurrentUserDone: UserConstants.FETCH_CURRENT_USER_DONE,
    updateGatesDone: GateConstants.GATES_UPDATE_DONE,
    setGateDone: GateConstants.SET_GATE_DONE
  },

  fetchCurrentUserDone(user) {
    const gates = user.gates || {}
    return this.setState({ gates })
  },

  updateGatesDone(gates) {
    return this.setState({ gates: gates || {}})
  },

  setGateDone(gates) {
    return this.setState({ gates: gates || {}})
  },

  getOrFetchGates() {
    return this.fetch({
      id: 'getOrFetchGates',
      dependsOn: this.app.stores.UserStore.getOrFetchCurrentUser(),
      locally() {
        return this.state.gates
      }
    })
  }
})

export default GateStore



// WEBPACK FOOTER //
// ./src/scripts/stores/GateStore.js